import { GamesLayoutType } from "component/common/gamesLayoutType";
import type { RootState } from "store/types";

// `window` (src/reducers/window.js) unwound at the selector boundary for containers/Games
// (PLAY-5160), following store/selectors/filters.ts's shape.
export function selectIsMobile(state: RootState): boolean {
  return !!state.window.get("isMobile");
}

export function selectDeviceSize(state: RootState): string | undefined {
  return state.window.get("deviceSize");
}

// Actually an Immutable Map (`{banner, icon, gamelobbyBanner, tournaments, logoRound}`, see
// reducers/window.js's defaultValue), not a string - the `string | undefined` annotation here
// predates this comment and was already worked around by both existing consumers
// (containers/GameNavigation's own locally-`any`-typed setBannerSrc, containers/Games passing it
// straight through as a prop). Fixed to `any` for containers/Category (PLAY-5216, Phase 3),
// which reads `.get("banner")` off it directly.
export function selectImageFormat(state: RootState): any {
  return state.window.get("imageFormat");
}

// containers/BetHistory, containers/JackpotDetails (PLAY-5216, Phase 1).
export function selectWindowHeight(state: RootState): number | undefined {
  return state.window.get("height");
}

// Only meaningful on mobile (portrait/landscape orientation) — mirrors
// mapStateToProps' `stateLayout = isMobile ? state.window.get("layout") : null`.
export function selectWindowLayout(state: RootState): string | undefined {
  return state.window.get("layout");
}

// containers/Application (PLAY-5216, Phase 4): stays Immutable - read with `.size` there.
export function selectWindowModals(state: RootState): any {
  return state.window.get("modals");
}

// Ports mapStateToProps' mobile gamesLayout orientation switch verbatim: on mobile,
// a "layout_2a"/"layout_2b" URL layout resolves to one or the other based on device
// orientation; every other layout value (including desktop) passes through unchanged.
export function deriveGamesLayout(
  layoutParam: string | undefined,
  isMobile: boolean,
  stateLayout: string | null | undefined,
): string {
  let gamesLayout = layoutParam || GamesLayoutType.LAYOUT_1;

  if (isMobile && (gamesLayout === "layout_2a" || gamesLayout === "layout_2b")) {
    switch (stateLayout) {
      case "portrait":
        gamesLayout = "layout_2b";
        break;
      default:
        gamesLayout = "layout_2a";
        break;
    }
  }

  return gamesLayout;
}
